export const API_URL = process.env.REACT_APP_API_URL;
export const COGNITO_REGION = process.env.REACT_APP_AWS_REGION;
export const COGNITO_USER_POOL_ID = process.env.REACT_APP_COGINITO_POOL_ID;
export const COGNITO_USER_APP_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;
